import { render } from "./dashboardNew.vue?vue&type=template&id=ba5c8cfc&scoped=true"
import script from "./dashboardNew.vue?vue&type=script&lang=js"
export * from "./dashboardNew.vue?vue&type=script&lang=js"

import "./dashboardNew.vue?vue&type=style&index=0&id=ba5c8cfc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5c8cfc"]])

export default __exports__